<template>
  <BaseTooltip tooltip="ProApp Intelligence" maxContent left>
    <button
      class="proapp-intelligence-trigger"
      type="button"
      :aria-label="open ? 'Close ProApp Intelligence' : 'Open ProApp Intelligence'"
      :aria-expanded="String(open)"
      @click="$emit('click')"
    >
      <img src="/favicon-32x32.png" alt="" aria-hidden="true" />
    </button>
  </BaseTooltip>
</template>

<script>
export default {
  name: 'ProAppIntelligenceFloatingButton',
  props: {
    open: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.proapp-intelligence-trigger {
  width: 58px;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--v-primary-base);
  box-shadow: 0 4px 4px rgba(133, 133, 133, 0.25);
  cursor: pointer;
  transition: transform 0.2s ease, filter 0.2s ease, box-shadow 0.2s ease;

  img {
    width: 38px;
    height: 38px;
    padding: 3px;
    border-radius: 50%;
    background: white;
  }

  &:hover {
    filter: brightness(92%);
    transform: translateY(-2px);
    box-shadow: 0 7px 12px rgba(39, 127, 175, 0.26);
  }

  &:focus-visible {
    outline: 3px solid var(--v-primary-lighten4);
    outline-offset: 3px;
  }
}
</style>
